import { createAsyncThunk } from '@reduxjs/toolkit';

import { LifeInsuApiPaths } from 'Feature/LifeInsu/Constant/LifeInsuApiPaths';
import { LifeInsuHttpGetService, LifeInsuHttpPostService } from 'Feature/LifeInsu/Services/LifeInsuHttpServices';

export const getPayPremiumInstallmentConfig = createAsyncThunk(
  'PremiumInstallment/GetPayPremiumInstallmentConfig',
  async () => {
    return await LifeInsuHttpGetService({
      url: `${LifeInsuApiPaths.PremiumInstallment.GetPayPremiumInstallmentConfig}`,
    });
  }
);

export const getInsurancePolicyInfoDetail = createAsyncThunk(
  'InsurancePolicyInfo/GetInsurancePolicyInfoDetail',
  async (query: any) => {
    return await LifeInsuHttpGetService({
      url: `${LifeInsuApiPaths?.InsurancePolicyInfo.GetInsurancePolicyInfoDetail}`,
      params: query,
    });
  }
);

export const getAllPremiumInstallmentPaidPagedFilter = createAsyncThunk(
  'PremiumInstallment/getAllPremiumInstallmentPaidPagedFilter',
  async (query: any) => {
    return await LifeInsuHttpGetService({
      url: `${LifeInsuApiPaths?.PremiumInstallment.GetAllPremiumInstallmentPaidPagedFilter}`,
      params: query,
    });
  }
);

export const getAllPremiumInstallmentUnPaidPagedFilter = createAsyncThunk(
  'PremiumInstallment/getAllPremiumInstallmentUnPaidPagedFilter',
  async (query: any) => {
    return await LifeInsuHttpGetService({
      url: `${LifeInsuApiPaths?.PremiumInstallment.GetAllPremiumInstallmentUnPaidPagedFilter}`,
      params: query,
    });
  }
);
export const createPremiumInstallment = createAsyncThunk(
  'PremiumInstallment/createPremiumInstallment',
  async (command: {
    insurancePolicyNumber: string;
    premiumInstallmens: {
      installmentNo: number;
      dueDate: string;
      amount: number;
    }[];
    holderNationalCode: string;
  }) => {
    return await LifeInsuHttpPostService({
      url: `${LifeInsuApiPaths?.PremiumInstallment.CreatePremiumInstallment}`,
      body: command,
    });
  }
);

export const createLoan = createAsyncThunk(
  'Loan/createLoan',
  async (command: {
    insurancePolicyNumber: string;
    loans: {
      loanNo: number;
      installmentNo: number;
      dueDate: string;
      amount: number;
    }[];
    holderFullName: string;
    holderNationalCode: string;
    insuredFullName: string;
    insuredNationalCode: string;
  }) => {
    return await LifeInsuHttpPostService({
      url: `${LifeInsuApiPaths?.Loan.CreateLoan}`,
      body: command,
    });
  }
);

export const getActiveLoan = createAsyncThunk('Loan/getActiveLoan', async (query: any) => {
  return await LifeInsuHttpGetService({
    url: `${LifeInsuApiPaths?.Loan.GetActiveLoan}`,
    params: query,
  });
});

export const getAllLoanPaidPagedFilter = createAsyncThunk('Loan/getAllLoanPaidPagedFilter', async (query: any) => {
  return await LifeInsuHttpGetService({
    url: `${LifeInsuApiPaths?.Loan.GetAllLoanPaidPagedFilter}`,
    params: query,
  });
});

export const getAllLoanUnPaidPagedFilter = createAsyncThunk('Loan/getAllLoanUnPaidPagedFilter', async (query: any) => {
  return await LifeInsuHttpGetService({
    url: `${LifeInsuApiPaths?.Loan.GetAllLoanUnPaidPagedFilter}`,
    params: query,
  });
});
